import styled from "styled-components";
import facesBg from "./../../../resources/images/icons/faces_bg.jpg";

const SpoilerBlock = styled.div`
  background: rgba(53, 48, 120, 0.2);
  border: 2px solid rgba(236, 235, 255, 0.1);
  border-radius: 12px;
  padding-left: 15px;
  padding-right: 15px;
  overflow: hidden;
  max-height: 71px;
  box-sizing: border-box;
  transition: 0.5s;
  &.open {
    max-height: 1000px;
  }
`;

SpoilerBlock.Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
SpoilerBlock.Bottom = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
`;

SpoilerBlock.Line = styled.div`
  border-bottom: 1px solid #252157;
  width: 100%;
`;

SpoilerBlock.Title = styled.div`
  height: 42px;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
  p {
    transition: 0.3s;
  }
  &.open {
    p {
      letter-spacing: 0.005em;
      text-shadow: 0 0 0.65px #ffffff, 0 0 0.65px #ffffff;
    }
  }
`;
SpoilerBlock.Icon = styled.div`
  width: 27px;
  height: 27px;
  min-width: 27px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
  margin-left: 25px;
  &.open {
    transform: rotate(180deg);
  }
`;

export { SpoilerBlock };
